import { render, staticRenderFns } from "./PrivacyView.vue?vue&type=template&id=2e9e1dae&scoped=true&"
import script from "./PrivacyView.vue?vue&type=script&lang=js&"
export * from "./PrivacyView.vue?vue&type=script&lang=js&"
import style0 from "./PrivacyView.vue?vue&type=style&index=0&id=2e9e1dae&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e9e1dae",
  null
  
)

export default component.exports